// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
import store from './store/'
import ElementUI from 'element-ui'
import axios from 'axios'
import { post } from '@/config/ajax'
// import 'element-theme-chalk'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/comment.css';


Vue.config.productionTip = false;
Vue.prototype.$post = post;
Vue.use(ElementUI);


router.beforeEach((to, from, next) => {
  // let islogin = localStorage.getItem('islogin')
  let token = localStorage.getItem('xctoken')
  let page = JSON.parse(localStorage.getItem('page'))
  // let nowtime = new Date().getTime()
  // console.log('aaaaa',to)
  if (token) { //判断是否登录态
    console.log('islogintrue')
    // if (page.indexOf(to.fullPath)!= -1) {
    //   next()
    // } else {
    //   next('/401')
    // }
    next()
  } else {
    if (to.path == '/') {
      next()
    } else {
      next('/')
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js